import { getActionStruct, getInitComboDraw, getInitComboDrawRange, getUniqCombosAndDraws } from './helpers'
import { viewerConstants } from '../_reducers/viewer'
import { actions as reportActions } from '../slices/Reports/reports'

export const removeLastToken = (query) => {
	const parsedArray = query.split('_')

	return parsedArray.slice(0, parsedArray.length).join('_')
}

export const toggleNavigationVisible = (payload) => ({
	type: viewerConstants.TOGGLE_NAVIGATION_VISIBLE,
	payload,
})

/* Set strategy filters*/
export const setStrategyFilters =
	({ filterType, filterData }) =>
	(dispatch) => {
		dispatch({
			type: viewerConstants.SET_STRATEGY_FILTERS,
			filterType,
			filterData,
		})
	}

export const setIsCrossTableLoading = (tablesLoading) => ({
	type: viewerConstants.VIEWER_AGG_REQUEST,
	isCrossTableLoading: tablesLoading,
})

export const setEquityActionStruct = (payload) => ({
	type: viewerConstants.SINGLE_EQUITY_ACTION,
	payload,
})

export const setEquityActionForTwoPlayers = (payload) => ({
	type: viewerConstants.SINGLE_EQUITY_TWO_PLAYERS,
	payload,
})

export const setMultiStackData = (multiStackData) => ({
	type: viewerConstants.SET_MULTISTACKS_DATA,
	multiStackData,
})

export const controlComboDrawVisible = (isCombosDrawsVisible) => ({
	type: viewerConstants.CONTROL_VISIBLE_COMBOS,
	isCombosDrawsVisible,
})

export const setSameCountOfActions = (structureWithSameCountOfAction, reducedArrBiggestAction) => ({
	type: viewerConstants.SET_SAME_COUNT_ACTIONS,
	structureWithSameCountOfAction,
	reducedArrBiggestAction,
})

export const setTimerCounter = (timerPercent, timerCounter) => {
	return {
		type: viewerConstants.SET_TIMER_COUNTER,
		timerPercent,
		timerCounter,
	}
}

export const setActiveCardTraceIndex = (index) => (dispatch) =>
	dispatch({
		type: viewerConstants.SET_ACTIVE_CARD_TRACE_INDEX,
		payload: index,
	})

export const setActiveQueryTraceIndex = (index) => (dispatch) =>
	dispatch({
		type: viewerConstants.SET_ACTIVE_QUERY_TRACE_INDEX,
		payload: index,
	})

export const setActiveViewerRequestQuery = (query) => (dispatch) =>
	dispatch({
		type: viewerConstants.SET_VIEWER_REQUEST_QUERY,
		payload: query,
	})

export const setGraphicsRelatedElementsState = (state) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_GRAPHICS_RELATED_ELEMENTS_STATE,
		payload: state,
	})
}

export const setIsSelectedStack = (payload) => ({
	type: viewerConstants.SET_IS_SELECTED_STACK,
	payload: payload,
})

export const setStreetType = (type) => ({
	type: viewerConstants.SET_TYPE_CARD_TRACE,
	payload: type,
})

export const resetCacheMultiStacks = (newCache = []) => {
	return {
		type: viewerConstants.RESET_CACHE,
		cacheAllStacks: newCache,
	}
}

export const setReportType = (reportsType) => ({
	type: viewerConstants.SET_REPORTS_TYPE,
	reportsType,
})

export const setRequestForMultiStack = (payload) => ({
	type: viewerConstants.REQUEST_MULTISTACK,
	payload,
})

export const setCombosDrawsForMultiStack =
	(activeStacks, isPosition, isMultiStack, isRake, isOpenRaise) => (dispatch, getState) => {
		const { strategies } = getState().view
		const { positionStrategies } = getState().reports.positionReport.positionData
		const rakeStrategies = getState().reports.rakeReport.rakeData.rakeStrategies
		const openRaiseStrategies = getState().reports.openRaiseReport.openRaiseData.openRaiseStrategies
		const { threshold } = getState().preferences.dataNew.common.matrix

		if (isPosition) {
			const filteredStr = positionStrategies.filter((item) => activeStacks.includes(item.player))
			const [positionsCombos, positionsDraws] = getUniqCombosAndDraws(filteredStr, threshold)

			dispatch(reportActions.setFilters({ positionsCombos, positionsDraws }))
		}

		if (isRake) {
			const filteredStrategies = rakeStrategies.filter((item) => activeStacks.includes(item.rake_open_name))
			const [rakeCombos, rakeDraws] = getUniqCombosAndDraws(filteredStrategies, threshold)

			dispatch(reportActions.setRakeFilters({ rakeCombos, rakeDraws }))
		}

		if (isOpenRaise) {
			const filteredStrategies = openRaiseStrategies.filter((item) => activeStacks.includes(item.rake_open_name))
			const [openRaiseCombos, openRaiseDraws] = getUniqCombosAndDraws(filteredStrategies, threshold)

			dispatch(reportActions.setOpenRaiseFilters({ openRaiseCombos, openRaiseDraws }))
		}

		if (strategies && isMultiStack) {
			const filteredStrategies = strategies.filter((item) => activeStacks.includes(item.stack))
			const [uniqCombos, uniqDraws] = getUniqCombosAndDraws(filteredStrategies, threshold)

			dispatch({
				type: viewerConstants.SET_COMBOS_MULTISTACK,
				allCombos: uniqCombos,
				allDraws: uniqDraws,
			})
		}
	}

export const setCombosAndDraws = () => (dispatch, getState) => {
	const { threshold } = getState().preferences.dataNew.common.matrix
	const { combos, draw, abs, villain_abs, equity, actions } = getState().view

	const comboDrawSet = combos && draw && abs && getInitComboDraw({ combos, draw, abs }, threshold)

	const comboDrawSetRange =
		combos && draw && abs && getInitComboDrawRange({ combos, draw, abs, villain_abs }, threshold)

	dispatch({
		type: viewerConstants.SET_COMBOS_AND_DRAWS,
		comboSet: comboDrawSet && comboDrawSet.comboSet,
		drawSet: comboDrawSet && comboDrawSet.drawSet,
		comboSetRange: comboDrawSetRange && comboDrawSetRange.comboSet,
		drawSetRange: comboDrawSetRange && comboDrawSetRange.drawSet,

		action_struct: combos && draw && abs && getActionStruct({ combos, draw, abs, equity, actions }, threshold),
		trace_action_struct: combos && draw && abs && getActionStruct({ combos, draw, abs, equity, actions }, threshold),
	})
}

export function getNextActions(data) {
	// prepare structure
	const NEXT_ACTIONS = {}
	NEXT_ACTIONS.actions = []
	NEXT_ACTIONS.pot = data.pot
	NEXT_ACTIONS.player = data.player
	NEXT_ACTIONS.type = 'action'
	NEXT_ACTIONS.query = data.currentQuery

	// fill data
	for (let i = 0; i < data.actions.length; i += 1) {
		NEXT_ACTIONS.actions.push({
			action: data.actions[i].action,
			nextType: data.actions[i].nextAction,
			query: data.actions[i].nextQuery,
			gto_range: data.actions[i].gto_range,
		})
	}

	return NEXT_ACTIONS
}

export const resetState = () => (dispatch) =>
	dispatch({
		type: viewerConstants.RESET_VIEWER_STATE,
	})

export const setReportInitializers = (query, spotId) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_AGGREGATED_REPORT_INITIALIZERS,
		payload: [query, spotId],
	})
}

/* Relocation viewer state*/

export const setOpacityFiltersMoveMode = (val) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_OPACITY_FILTERS_MOVE_MODE,
		payload: val,
	})
}

export const setOnePlayerOpacityFilters =
	({ filterType, filterData }) =>
	(dispatch) => {
		dispatch({
			type: viewerConstants.SET_ONE_PLAYER_OPACITY_FILTERS,
			filterType,
			filterData,
		})
	}

export const setTwoPlayersOpacityFilters =
	({ filterType, filterData }) =>
	(dispatch) => {
		dispatch({
			type: viewerConstants.SET_TWO_PLAYERS_OPACITY_FILTERS,
			filterType,
			filterData,
		})
	}

/* Set range filters*/
export const setRangeFilters =
	({ filterType, filterData }) =>
	(dispatch) => {
		dispatch({
			type: viewerConstants.SET_RANGE_FILTERS,
			filterType,
			filterData,
		})
	}

export const setEQBucketsFilterRangeActiveCount = (activeType, activeCount) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_EQ_BUCKETS_FILTER_RANGE_ACTIVE_COUNT,
		activeType,
		activeCount,
	})
	dispatch({
		type: viewerConstants.SET_EQ_BUCKETS_FILTER_RANGE_ACTIVE_COUNT,
		payload: activeCount,
	})
}

export const setNewEquityBuckets = (buckets) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_EQ_NEW_BUCKETS,
		payload: buckets,
	})
}

export const setCombosFilterRangeActiveCount = (filterCount) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_COMBOS_FILTER_RANGE_ACTIVE_COUNT,
		payload: filterCount,
	})
}
export const setDrawsFilterRangeActiveCount = (filterCount) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_DRAWS_FILTER_RANGE_ACTIVE_COUNT,
		payload: filterCount,
	})
}

export const setSelectedHandsOnePlayer = (hands) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_SELECTED_HANDS_ONE_PLAYER,
		payload: hands,
	})
}
export const setSelectedHandsTwoPlayers = (hands) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_SELECTED_HANDS_TWO_PLAYERS,
		payload: hands,
	})
}

export const setSelectedGraphicPoints = (points) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_SELECTED_POINTS_GRAPHIC,
		payload: points,
	})
}

export const setSelectedEVGraphicPoints = (points) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_SELECTED_POINTS_EV_GRAPHIC,
		payload: points,
	})
}

export const setViewerViewMode = (view) => ({
	type: viewerConstants.SET_VIEWER_VIEW_MODE,
	payload: view,
})

export const setViewModeOnePlayer = (view) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_VIEW_MODE_ONE_PLAYER,
		payload: view,
	})
}
export const setViewModeTwoPlayers = (view) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_VIEW_MODE_TWO_PLAYERS,
		payload: view,
	})
}

export const setMoveCellRangeMode = (value) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_MOVE_CELL_MODE_RANGE,
		payload: value,
	})
}
export const setMoveCellStrategyMode = (value) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_MOVE_CELL_MODE_STRATEGY,
		payload: value,
	})
}

export const setActiveTabKeyTwoPlayersFilters = (tab) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_VIEW_ACTIVE_TWO_PLAYERS_FILTERS_TAB,
		payload: tab,
	})
}

export const setActiveTabKeyStrategy = (tab) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_VIEW_ACTIVE_TABLE_STRATEGY,
		payload: tab,
	})
}

export const setIsBoardFromFastSpots = (value) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_IS_FAST_POSTFLOP_BOARD,
		payload: value,
	})
}

export const setIsBoardFromSunburst = (value) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_IS_SUNBURST_BOARD,
		payload: value,
	})
}

export const setNextSunburstStreet = (value) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_NEXT_SUNBURST_STREET,
		payload: value,
	})
}

export const setIsBoardModalVisible = (isCommonBoard, isBoardFromFastSpots, isBoardFromSunburst) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_BOARD_MODAL_OPEN,
		payload: isCommonBoard,
	})

	if (isBoardFromSunburst) {
		dispatch(setIsBoardFromSunburst(!isBoardFromSunburst))
		dispatch(setSunburstQuery(''))
	}

	if (isBoardFromFastSpots) {
		dispatch(setIsBoardFromFastSpots(!isBoardFromFastSpots))
		dispatch(setFastPostFlopQuery(''))
	}
}

export const setFastPostFlopQuery = (fastQuery) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_FAST_POSTFLOP_QUERY,
		payload: fastQuery,
	})
}

export const setSunburstQuery = (sunQuery) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_SUNBURST_QUERY,
		payload: sunQuery,
	})
}

export const resetLibrarySpotId = (spotId) => (dispatch) => {
	dispatch({
		type: viewerConstants.RESET_LIBRARY_SPOTID,
		payload: spotId,
	})
}

export const setSunburstHistory = (sunburstHistory) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_SUNBURST_HISTORY,
		payload: sunburstHistory,
	})
}

export const setToggleFastPostFlopModal = (value) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_TOGGLE_FAST_POSTFLOP_MODAL,
		payload: value,
	})
}

export const setLineSPFData = (value) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_LINE_SPF_DATA,
		payload: value,
	})
}

export const setTooltipSizings = (payload) => (dispatch) => {
	dispatch({
		type: viewerConstants.SET_TOOLTIP_SIZINGS,
		payload,
	})
}

export const setMultiStacks = (payload) => ({
	type: viewerConstants.SET_MULTISTACKS,
	payload,
})

export const setFastPostFlopId = (payload) => {
	return {
		type: viewerConstants.SET_FAST_POSTFLOP_SPOT_ID,
		payload,
	}
}
